var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/**
 *  https://www.cnblogs.com/shn11160/archive/2012/08/27/2658057.html
 * ellipsis polyfill
 */
import Shape from './Shape';
import { pointInEllipseFill, pointInEllipseStroke } from '../geometry/contain/ellipse';
var shapeKeys = ['cx', 'cy', 'rx', 'ry'];
var Circle = /** @class */ (function (_super) {
    __extends(Circle, _super);
    function Circle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'ellipse';
        _this.shapeKeys = shapeKeys;
        return _this;
    }
    Circle.prototype.getDefaultAttr = function () {
        return __assign(__assign({}, _super.prototype.getDefaultAttr.call(this)), { cx: 0, cy: 0, rx: 0, ry: 0 });
    };
    Circle.prototype.getAnimationKeys = function () {
        return __spreadArrays(_super.prototype.getAnimationKeys.call(this), ['cx', 'cy', 'rx', 'ry']);
    };
    Circle.prototype.brush = function (ctx) {
        var _a = this.attr, cx = _a.cx, cy = _a.cy, rx = _a.rx, ry = _a.ry;
        ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
        //  polyfill
        //  ctx.save();
        //  choose Max(a, b) as the arc radius
        //  const r = (rx > ry) ? rx : ry;
        //  const ratioX = rx / r;
        //  const ratioY = ry / r;
        //  ctx.scale(ratioX, ratioY);
        //  ctx.beginPath();
        //  ctx.moveTo((cx + rx) / ratioX, cy / ratioY);
        //  ctx.arc(cx / ratioX, cy / ratioY, r, 0, 2 * Math.PI);
        //  ctx.closePath();
        //  ctx.restore();
    };
    Circle.prototype.isPointInFill = function (x, y) {
        var _a = this.attr, cx = _a.cx, cy = _a.cy, rx = _a.rx, ry = _a.ry;
        return pointInEllipseFill(cx, cy, rx, ry, x, y);
    };
    Circle.prototype.isPointInStroke = function (x, y, lineWidth) {
        var _a = this.attr, cx = _a.cx, cy = _a.cy, rx = _a.rx, ry = _a.ry;
        return pointInEllipseStroke(cx, cy, rx, ry, lineWidth, x, y);
    };
    Circle.prototype.computeBBox = function () {
        var _a = this.attr, cx = _a.cx, cy = _a.cy, rx = _a.rx, ry = _a.ry;
        return {
            x: cx - rx,
            y: cy - ry,
            width: rx * 2,
            height: ry * 2,
        };
    };
    return Circle;
}(Shape));
export default Circle;
